<template>
  <div>
    <div>
      <Row :gutter="8">
        <Col span="3">
          <Button type="primary" icon="ios-search" long @click="searchByConditionsView">按条件查询</Button>
        </Col>
        <!--Col span="3">
                <Button icon="md-cloud-download" long type="primary" @click="exportMeterInfoTemplate">导出设备模板</Button>
                </Col>
                <Col span="3">
                <Button type="primary" icon="md-cloud-upload" long onclick="$('#upload_file_meter').click();">按设备模板导入</Button>
                </Col>
                <Col span="3">
                <Upload ref="upload" name="upfile" action="/api/importMeterInfoTemplate" :on-success="handleImportMeterInfoTemplate"
                    :format="['xlsx','xls']" :show-upload-list="false" :on-error="handleError">
                    <input id="upload_file_meter" style="display: none;" />
                </Upload>
        </Col-->
      </Row>
    </div>

    <!-- 模态框 -->
    <div>
      <Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>按条件检索</span>
        </p>
        <div style="text-align:center">
          <CheckboxGroup v-model="selectedCondition" class="check_grop">
            <div>
              <Row type="flex" justify="center" align="middle">
                <Col span="9" style="text-align: right;margin=left:5px">
                  <Checkbox label="deviceId">
                    <span>设备编号</span>
                  </Checkbox>
                </Col>
                <Col span="15" style="text-align: left">
                  <Input v-model="deviceIdModel" placeholder="请输入设备编号" style="width: 150px" />
                </Col>
              </Row>
            </div>
            <div>
              <Row type="flex" justify="center" align="middle">
                <Col span="9" style="text-align: right;margin=left:5px">
                  <Checkbox label="idcard">
                    <span>证件编号</span>
                  </Checkbox>
                </Col>
                <Col span="15" style="text-align: left">
                  <Input v-model="idcardModel" placeholder="请输入证件编号" style="width: 150px" />
                </Col>
              </Row>
            </div>
            <div>
              <Row type="flex" justify="center" align="middle">
                <Col span="9" style="text-align: right;margin=left:5px">
                  <Checkbox label="name">
                    <span>户主姓名</span>
                  </Checkbox>
                </Col>
                <Col span="15" style="text-align: left">
                  <Input v-model="nameModel" placeholder="请输入户主姓名" style="width: 150px" />
                </Col>
              </Row>
            </div>
            <div>
              <Row type="flex" justify="center" align="middle">
                <Col span="9" style="text-align: right;margin=left:5px">
                  <Checkbox label="openAddress">
                    <span>开户地址</span>
                  </Checkbox>
                </Col>
                <Col span="15" style="text-align: left">
                  <Cascader
                    v-model="openAddressModel"
                    placeholder="请选择开户地址"
                    :data="addressData"
                    filterable
                    change-on-select
                    trigger="click"
                    style="width: 150px"
                  ></Cascader>
                </Col>
              </Row>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
        </div>
      </Modal>
    </div>

    <!-- 模态框 -->
    <div>
      <Modal title="Title" v-model="modal9" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>修改设备类型</span>
        </p>
        <div style="text-align:center">
          <div>
            <Row type="flex" justify="center" align="middle">
              <Col span="9" style="text-align: right;">
                <span>设备编号</span>
              </Col>
              <Col span="15" style="text-align: left">
                <Input
                  readonly
                  v-model="updateForm.meterId"
                  placeholder="请输入设备编号"
                  style="padding-left:10px;width: 150px"
                />
              </Col>
            </Row>
          </div>
          <div>
            <Row type="flex" justify="center" align="middle">
              <Col span="9" style="text-align: right;">
                <span>设备类型</span>
              </Col>
              <Col span="15" style="text-align: left">
                <Select
                  v-model="updateForm.meterType"
                  style="padding-left:10px; width:150px"
                  placeholder="请选设备类型"
                >
                  <Option v-for="(value, key) in meterType" :value="key" :key="key">{{value}}</Option>
                </Select>
              </Col>
            </Row>
          </div>
        </div>
        <div slot="footer">
          <Button icon="md-search" type="info" size="large" long @click="commitUpdateMeterType">提交修改</Button>
        </div>
      </Modal>
    </div>
    <br />
    <Table
      id="responseTable"
      style="background:red"
      size="small"
      border
      stripe
      :loading="loading"
      :columns="columns1"
      :data="data1"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="updateMeterType(row)"
        >修改设备类型</Button>
      </template>
    </Table>
    <br />
    <Page
      :current="pageNo"
      :total="pageTotal"
      :page-size="pageSize"
      :page-size-opts="[5, 10, 20, 30, 40]"
      show-sizer
      show-total
      @on-change="changePage"
      @on-page-size-change="changePageSize"
    />
  </div>
</template>

<script>
import expandRow from "./expand/MeterTableExpand.vue";
import { constants } from "crypto";
export default {
  name: "meter_menu",
  created() {},
  mounted() {
    // this.tableHeight =
    //   window.innerHeight - this.$refs.table.$el.offsetTop - 160;
    this.getAddresTree();
  },
  created() {
    this.request();
  },
  methods: {
    updateMeterType(row) {
      console.log(row);
      this.updateForm.meterId = row.meterId;
      this.modal9 = true;
    },
    commitUpdateMeterType() {
      console.log(this.updateForm);

      if (localStorage.getItem("isAdmin") == "false") {
        that.isModalShow = false;
        that.$Notice.info({
          title: "提示",
          desc: "您的权限不足！"
        });
        return;
      }

      if (this.updateForm.meterType == "" || this.updateForm.meterId == "") {
        this.$Notice.info({
          title: "提示",
          desc: "请输入正确的设备编号或设备类型"
        });
        return;
      }
      var that = this;
      that.loading = true;
      that.modal9 = false;
      $.ajax({
        url: "/api/InfoMeter/update",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.updateForm),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "修改成功"
          });
          that.request();
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.loading = false;
        }
      });
    },
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, date);
    },
    exportMeterInfoTemplate() {
      window.location.href = this.meterInfoUrl;
    },
    handleImportMeterInfoTemplate(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.handelResponse(response);
    },
    handelResponse(response) {
      if (response.errorCode != 0) {
        this.$Notice.error({
          title: "导入失败",
          desc: response.errorInfo,
          duration: 0
        });
      } else {
        let result = response.body.repeatArray;
        let insert = response.body.insertArray;
        let count = "\n共计导入" + insert.length + "条数据。";
        let indexs = "";
        if (result.length > 0) {
          result.map(item => {
            indexs =
              indexs == "" ? item.index + 2 : indexs + "," + (item.index + 2);
          });
        }
        let msg =
          indexs == ""
            ? ""
            : "\n第" + indexs + "行数据与数据库中数据重复,不予导入。";
        this.$Notice.success({
          title: "成功",
          desc: "导入成功！" + msg + count,
          duration: 0
        });
        this.request();
      }
    },
    handleError(error, file, fileList) {
      console.log(error);
      console.log(file);
      console.log(fileList);
      this.$Notice.error({
        title: "导入失败",
        desc: error,
        duration: 0
      });
    },
    request() {
      var that = this;
      this.pageNo = 1;
      $.ajax({
        url: "/api/getMeterInfoByConditions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          direction: "down",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "载入设备数据成功"
          });
          that.data1 = data.body.resultList;
          that.pageTotal = data.body.amount;
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },

    ok() {},
    cancel() {},
    del() {},
    // 修改页面容量
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.request();
    },
    // 修改
    changePage(index) {
      this.pageNo = index;
      var that = this;
      that.loading = true;
      $.ajax({
        url: "/api/getMeterInfoByConditions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          direction: "down",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.data1 = data.body.resultList;
            that.pageTotal = data.body.amount;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    getAddresTree() {
      var that = this;
      $.ajax({
        url: "/api/getAddressTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressData = data.body[0].children;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "地址获取异常"
          });
        }
      });
    },
    // 按条件检索点击事件
    searchByCondition() {
      this.requestBody = {};

      for (var temp in this.selectedCondition) {
        if (this.selectedCondition[temp] == "deviceId") {
          if (this.deviceIdModel == "") {
            continue;
          }

          this.requestBody["deviceId"] = this.deviceIdModel;
          // requestBody.set("deviceId", this.deviceIdModel);
        }
        if (this.selectedCondition[temp] == "idcard") {
          if (this.idcardModel == "") {
            continue;
          }

          this.requestBody["idcardModel"] = this.idcardModel;
          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition[temp] == "name") {
          if (this.nameModel == "") {
            continue;
          }
          this.requestBody["nameModel"] = this.nameModel;
        }
        if (this.selectedCondition[temp] == "openAddress") {
          if (this.openAddressModel == "") {
            continue;
          }
          this.requestBody["openAddress"] = this.openAddressModel[
            this.openAddressModel.length - 1
          ];
        }
      }

      // 调用接口查询
      var that = this;
      that.loading = true;
      this.modal8 = false;
      this.pageNo = 1;
      // if(that.requestBody.openAddress){
      //     that.requestBody.openAddress = that.requestBody.openAddress * 1;
      // }
      $.ajax({
        url: "/api/getMeterInfoByConditions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          direction: "down",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.$Notice.success({
              title: "提示",
              desc: "载入设备数据成功"
            });
            that.data1 = data.body.resultList;
            that.pageTotal = data.body.amount;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    // 显示条件检索页面
    searchByConditionsView() {
      this.modal8 = true;
    },
    handleClose2(event, name) {
      const index = this.count.indexOf(name);
      this.count.splice(index, 1);
    },
    // 点击事件：点击显示数据集
    showData(row, index) {
      // 遍历数据集拼接HTML
      var htmlStr =
        "<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; '>";
      var amount = 0;
      for (let temp in row.data) {
        if (amount % 2 == 0) {
          htmlStr += "<tr >";
        }
        htmlStr +=
          "<td style='margin-top:2px; border: 1px solid #C0C0C0;'>" +
          temp +
          "</td><td style='margin-top:2px; border: 1px solid #C0C0C0;'>" +
          row.data[temp] +
          "</td>";
        if (amount % 2 == 1) {
          htmlStr += "</tr>";
        }
        amount++;
      }
      htmlStr += "</table>";

      this.selectDataHtml = htmlStr;
      this.selectData = row.data;
      // this.showDrawer = true;

      this.$Notice.open({
        title: "存储编号:" + row.saveId + "\t设备编号:" + row.deviceId,
        desc: htmlStr,
        // JSON.stringify(row.data),
        duration: 5
      });
    }
  },
  components: {
    expandRow
  },
  data() {
    return {
      meterType: global.meterType,
      columns1: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: "设备编号",
          key: "meterId",
          sortable: true
        },
        {
          title: "设备信息",
          children: [
            {
              title: "设备厂商",
              key: "meterManufacturer",
              sortable: true
            },
            {
              title: "设备规格",
              key: "meterSpecifications"
            },
            {
              title: "设备入库时间",
              key: "meterCreatedDate"
            }
          ]
        },
        {
          title: "修改设备类型",
          slot: "action",
          width: 150,
          align: "center"
        }
      ],
      addressData: [],
      data1: [],
      loading: true,
      showDrawer: false,
      selectDataHtml: "",
      selectData: {},
      modal8: false,
      modal9: false,
      pageTotal: 0,
      pageSize: 5,
      selectedCondition: [],
      commandEnum: global.command,
      saveIdModel: "",
      deviceIdModel: "",
      openAddressModel: "",
      nameModel: "",
      idcardModel: "",
      commandIdModel: "",
      timeStampModel: "",
      pageNo: 1,
      requestBody: {},
      meterInfoUrl: "/api/downloadMeterInfoTemplate",
      updateForm: {
        meterId: "",
        meterType: ""
      }
    };
  }
};
</script>

<style>
.ivu-notice-notice {
  width: 500px;
  right: 160px;
}

.query_condition {
  border: 1px solid #c0c0c0;
  padding: 2px;
  margin: 2px;
  border-radius: 5%;
}

.check_grop div {
  margin-bottom: 1px;
}

#responseTable /deep/ .ivu-table td {
  min-width: 0;
  height: 40px;
  box-sizing: border-box;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  border-bottom: 1px solid #e8eaec;
}
</style>
